import {EnlilTable} from "../EnlilTable";
import withNavigate from "../../util/useNavigate";
import {withAppContext} from "../../util/withAppContext";

class DeveloperTypeTable extends EnlilTable {
}

export default withNavigate(withAppContext(DeveloperTypeTable));